import axios from "@axios" //eslint-disable-line

export default {
    /*
     * main programs API
     */
    getPrograms(params = {}) {
        return axios.post('/programs/retrieve', params)
    },
    getProgramOwners(params = {}) {
        return axios.get('/accounts/program-owners', { params })
    },
    getProgramTrends(uuid, params = {}) {
        return axios.get(`/programs/${uuid}/trends`, { params })
    },
    addProgram(data) {
        return axios.post('/programs', data)
    },
    getProgram(uuid) {
        return axios.get(`/programs/${uuid}`)
    },
    getProgramListFilters() {
        return axios.get('/programs/filters')
    },
    getProgramTrendSummary(uuid) {
        return axios.get(`/programs/${uuid}/trends/summary`)
    },
    updateProgram(uuid, data) {
        return axios.put(`/programs/${uuid}`, data)
    },
    updateProgramStatus(uuid, data) {
        return axios.put(`/programs/${uuid}/status`, data)
    },
    getProgramHistory(uuid) {
        return axios.get(`/programs/${uuid}/history`)
    },
    getGeoCountries() {
        return axios.get('/countries')
    },
    getGeoLocations() {
        return new Promise((resolve, reject) => {
            axios
                .get('/locations')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    },
    getTargetingSetHistory(uuid) {
        return axios.get(`/targeting-sets/${uuid}/history`)
    },
    getTargetingSetsPaginated(params) {
        return axios.get('/targeting-sets/paginated', { params })
    },
    getTargetingSets(params = {}) {
        return axios.get('/targeting-sets', { params })
    },
    updateTargetingSet(uuid, data, params = {}) {
        return axios.put(`/targeting-sets/${uuid}`, data, { params });
    },
    getTargetingSet(uuid, params = {}) {
        return axios.get(`/targeting-sets/${uuid}`, {
            params: {
                includes: [ 'countries', 'creatives' ],
                creatives_drafts: true,
                targetingSets_spend: true,
                include_bid_positions: true,
                ...params,
            },
        })
    },
    deleteTargetingSet(uuid) {
        return axios.delete(`/targeting-sets/${uuid}`)
    },
    addTargetingSet(data) {
        return axios.post('/targeting-sets', data)
    },
}
